import { render, staticRenderFns } from "./selectService.vue?vue&type=template&id=58cd8cd6&scoped=true&"
import script from "./selectService.js?vue&type=script&lang=js&"
export * from "./selectService.js?vue&type=script&lang=js&"
import style0 from "./selectService.styl?vue&type=style&index=0&id=58cd8cd6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cd8cd6",
  null
  
)

export default component.exports